// TODO(CONON-1972): Remove this beta header override once we upgrade to the latest API version that includes the expanded set of `requirements.errors` codes
export const updatedRequirementErrorsBetaHeaderApolloOptions = {
  variables: {
    v1Context: {
      betaHeaders: {
        updated_requirement_errors_beta: 'v1',
      },
    },
  },
};
